import { render } from "./faltan_ingles.vue?vue&type=template&id=5a443ecd&scoped=true"
import script from "./faltan_ingles.vue?vue&type=script&lang=js"
export * from "./faltan_ingles.vue?vue&type=script&lang=js"

import "./faltan_ingles.vue?vue&type=style&index=0&id=5a443ecd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a443ecd"]])

export default __exports__